import { Component, OnInit, OnDestroy, ElementRef, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LanguageService, LanguageConfig, POPULAR_LANGUAGES } from '../../../core/services/language/language.service';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  private readonly languageService = inject(LanguageService);
  private readonly elementRef = inject(ElementRef);

  public isOpen = false;
  public currentLang: LanguageConfig = this.languageService.currentLanguage;
  public popularLanguages: LanguageConfig[] = POPULAR_LANGUAGES;

  private sub?: Subscription;

  ngOnInit(): void {
    this.sub = this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLang = lang;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  public toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  public closeDropdown(): void {
    this.isOpen = false;
  }

  public selectLanguage(lang: LanguageConfig): void {
    this.languageService.setLanguage(lang);
    this.closeDropdown();
  }

  @HostListener('document:click', ['$event'])
  onDocClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeDropdown();
  }
}
